import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";

import { AuthProvider } from "@/lib/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import PaywallGate from "@/components/PaywallGate";
import AuthCallback from "@/pages/AuthCallback";

import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import ProfilePage from "@/pages/ProfilePage";
import Universities from "@/pages/Universities";
import UniversityDetail from "@/pages/UniversityDetail";
import Compare from "@/pages/Compare";
import Financial from "@/pages/Financial";
import Advisor from "@/pages/Advisor";
import TopPicks from "@/pages/TopPicks";
import DecisionReport from "@/pages/DecisionReport";
import DecisionReportDetail from "@/pages/DecisionReportDetail";
import OneDecisionReport from "@/pages/OneDecisionReport";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/universities" element={<Universities />} />
      <Route path="/universities/:slug" element={<UniversityDetail />} />
      <Route path="/compare" element={<Compare />} />
      <Route path="/financial" element={<PaywallGate><Financial /></PaywallGate>} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
      <Route path="/advisor" element={<PaywallGate><Advisor /></PaywallGate>} />
      <Route path="/top-picks" element={<TopPicks />} />
      <Route path="/decision-report" element={<PaywallGate><DecisionReport /></PaywallGate>} />
      <Route path="/decision-report/one" element={<PaywallGate><OneDecisionReport /></PaywallGate>} />
      <Route path="/decision-report/:slug" element={<PaywallGate><DecisionReportDetail /></PaywallGate>} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </AuthProvider>
  );
}
